import React, { useEffect } from 'react'
import { InviteUserPageProps } from './InviteUserPage.types'
import styles from './InviteUserPage.module.scss'
import cl from 'classnames'
import {
  Button,
  H2,
  HorizontalLine,
  ImageLabelLine,
  Input,
  LabeledLine,
  NoneLabel,
  PageHeader,
  SectionContainer,
  Text1
} from 'components/shared'
import {
  IconCalendar,
  IconEmail,
  IconPeople,
  IconUserManagement
} from 'assets'
import { Select } from 'components/shared/Select'
import { User } from 'utilities'
import moment from 'moment'
import { inject } from 'mobx-react'
import { INVITE_USER_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import { capitalize } from 'validate.js'
import { UserProjectsSection } from '../UserProjectsSection'
// import { toJS } from 'mobx'

const InviteUserPageComponent = (props: InviteUserPageProps) => {
  const {
    className,
    style,
    history: {
      push,
      goBack
    },
    [INVITE_USER_STORE]: {
      user,
      setUserProps,
      getUserRoles,
      userRoleOptions,
      selectedUserRoleId,
      onUserRoleSelect,
      linkToEntityType,
      isLinkToEntityRoleSelected,
      selectedLinkToEntityId,
      linkToEntityOptions,
      canAssignProjects,
      isFormValid,
      setLinkToEntityId,
      onGoToLinkedEntityPageClick,
      sendInvitation,
      projectOptions,
      assignProject,
      hasAssignedProjects
    }
  } = props

  useEffect(getUserRoles, [getUserRoles])

  return (
    <div
      className={cl(styles.pageContainer, styles.scrollable, className)}
      style={style}
    >
      <PageHeader
        navSegments={[
          {
            label: 'User management',
            icon: IconUserManagement,
            onClick: () => push('/user-management'),
            iconProps: { viewBox: '0 0 22 22' }
          },
          {
            label: 'Invite user'
          }
        ]}
        buttons={[
          {
            children: 'Discard',
            preset: 'secondary',
            onClick: goBack
          },
          {
            children: 'Send',
            preset: 'primary',
            onClick: sendInvitation,
            disabled: !isFormValid
          }
        ]}
      />

      <SectionContainer extraPaddingBottom>
        <div className={styles.basicInfoContainer}>
          <LabeledLine
            label='Email'
            labelIcon={IconEmail}
            className={styles.leftFieldsContainer}
            style={{ marginTop: 0 }}
          >
            <Input
              placeholder='Email'
              type='email'
              autoComplete='email'
              value={user.emailAddress}
              onChange={emailAddress => setUserProps({
                emailAddress: emailAddress.trim().toLowerCase()
              })}
            />
          </LabeledLine>
          <div className={styles.rightFieldsContainer}>
            <LabeledLine
              label='Added on'
              labelIcon={IconCalendar}
              style={{ marginTop: 0 }}
            >
              <Text1>
                {moment().format('DD.MM.YYYY') + ' '}
              (today)
              </Text1>
            </LabeledLine>
            <LabeledLine
              label='Added by'
              labelIcon={IconPeople}
            >
              <Text1 overflowEllipsis>
                {User.fullName} (you)
              </Text1>
            </LabeledLine>
          </div>
        </div>
        <HorizontalLine />
        <div className={styles.basicInfoContainer}>
          <LabeledLine
            label='Role'
            className={styles.leftFieldsContainer}
            style={{ marginTop: 0 }}
          >
            <Select
              noNoneOption
              value={selectedUserRoleId}
              options={userRoleOptions}
              onChange={onUserRoleSelect}
            />
          </LabeledLine>
          <div className={styles.rightFieldsContainer}>
            {isLinkToEntityRoleSelected && (
              <>
                <LabeledLine
                  // label={`Link to `}
                  label={`Link to ${linkToEntityType}`}
                  // className={styles.leftFieldsContainer}
                  style={{ marginTop: 0, width: '50%' }}
                >
                  <Select
                    noNoneOption
                    value={selectedLinkToEntityId}
                    options={linkToEntityOptions}
                    customOptionComponent={ImageLabelLine}
                    onChange={setLinkToEntityId}
                  />
                </LabeledLine>
                <Button
                  preset='link'
                  style={{ marginLeft: 20 }}
                  onClick={onGoToLinkedEntityPageClick}
                  disabled={!selectedLinkToEntityId}
                >
                  Go to {capitalize(linkToEntityType)} page
                </Button>
              </>
            )}
          </div>
        </div>
      </SectionContainer>

      {canAssignProjects && (
        <UserProjectsSection
          hasAssignedProjects={hasAssignedProjects}
          assignProject={assignProject}
          projectOptions={projectOptions}
        />
      )}

      <SectionContainer style={{ marginTop: 20 }}>
        <H2>Action history</H2>
        <NoneLabel label='No history yet.' />
      </SectionContainer>
    </div>
  )
}

const InviteUserPage = inject(
  INVITE_USER_STORE
)(observer(InviteUserPageComponent))
export { InviteUserPage }
